import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChallengeScheme } from "client-v2";
import { useDispatch, useSelector } from "react-redux";
import { actionsCreators, State } from "../../redux";
import { bindActionCreators } from "redux";

import Success from "../../components/section/success/Success";
import WizardContainer, {
	WizardContainerRef,
} from "../../components/container/WizardContainer";
import PaymentMethod from "../../components/section/donation/PaymentMethod";
import Price from "../../components/section/donation/Price";
import SuccessCrossSell from "../../components/section/success/SuccessCrossSell";

const Checkout = (props: Props) => {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const { setShowError } = bindActionCreators(actionsCreators, dispatch);
	const isMobile: boolean = useSelector(
		(state: State) => state.screen.isMobile
	);
	const currentUser = useSelector((state: State) => state.user.currentUser);

	const wizard = useRef<WizardContainerRef>(null);

	const view = "challenge";

	const [challenge, setChallenge] = useState<ChallengeScheme | undefined>(
		undefined
	);
	const [didSubscribe, setDidSubscribe] = useState(false);
	const [selectedPrice, setSelectedPrice] = useState<number | undefined>(
		undefined
	);
	const [completed, setCompleted] = useState(false);

	useEffect(() => {
		//init
		if (location.state && location.state.challenge) {
			setChallenge(location.state.challenge);
			const restAmount =
				location.state.challenge.goal - location.state.challenge.amount;
			if (restAmount <= 0) setCompleted(true);
		} else {
			navigate("/");
		}
	}, []);

	return (
		<WizardContainer
			ref={wizard}
			views={[
				//Price
				{
					centralView: challenge && (
						<Price
							challenge={challenge}
							view={view}
							options={["unique"]}
							defaultGrowthbook={{
								title: challenge.to
									? `Ayúdanos a cumplir el sueño de ${challenge.to.title}`
									: "Ayúdanos a cumplir el sueño",
								title_en: "How much do you want to contribute?",
								subtitle: "",
								subtitle_en: "",
								type_to_eur: 1,
								type: "",
								type_en: "",
							}}
							onFinish={(result) => {
								if (result.error) {
									setShowError({
										show: true,
										message: result.error,
									});
								} else if (result.data) {
									setSelectedPrice(result.data.price);
									wizard.current?.goNext();
								}
							}}
						/>
					),
					// rightView: challenge && (
					// 	<ResumeCheckout
					// 		challenge={challenge}
					// 		amount={
					// 			location.state && location.state.supporters
					// 				? location.state.supporters
					// 				: 0
					// 		}
					// 	/>
					// ),
					// rightViewStyle: {
					// 	display: isMobile ? "none" : "flex",
					// },
				},
				//Select payment method
				{
					centralView:
						selectedPrice && currentUser && challenge ? (
							<PaymentMethod
								challenge={challenge}
								amount={selectedPrice}
								user={currentUser}
								view={view}
								onFinish={(result) => {
									if (result.error) {
										setShowError({
											show: true,
											message: result.error,
										});
									} else if (result.data) {
										setDidSubscribe(true);
										wizard.current?.goNext();
									}
								}}
							/>
						) : null,
				},
				//Success view
				{
					hideNavBar: true,
					centralView:
						currentUser && challenge ? (
							<Success
								title={`¡Gracias por tu donación, ${currentUser.name}!`}
								subtitle="Con tu ayuda y la de otras muchas personas podremos cumplir el sueño."
								type="challenge"
								user={currentUser}
								challenge={challenge}
								steps={[
									{
										title: "Esperamos a tener todo el dinero para cumplir el sueño",
										subtitle: "Esto es lo que lleva más tiempo, pero una vez lo tengamos nos ponemos manos a la obra."
									},
									{
										title: "Preparamos el sueño",
										subtitle: "Cuidamos hasta el último detalle para que sea una experiencia inolvidable y todo salga perfecto.",
									},
									{
										title: "Os lo contamos por redes",
										subtitle: "El día elegido grabaremos la experiencia para que no os perdáis nada.",
									}
								]}
							/>
						) : null,
					rightView: !isMobile ? <SuccessCrossSell /> : null,
					hideBackButton: true,
				},
			]}
		/>
	);
};
export default Checkout;
export interface Props {}
